<div [formGroup]="form" class="flex-row">
    @if (multiple) {
        <mat-form-field class="flex"
        >
            <mat-label>{{ label }}</mat-label>
            <mat-select formControlName="selectElement"
                        multiple
                        [panelClass]="panelClass"
                        [(value)]="value"
                        (selectionChange)="updateSelectElement()"
                        [disabled]="disabled">
                <select-all-option [selectElement]="form.get('selectElement')"
                                   (checkAllCheckboxChangedEventEmitter)="checkAllCheckboxElementChanged($event)"
                                   [updateSelectElement]="updateSelectElement"
                                   [values]="allOptions">
                </select-all-option>
                @for (option of allOptions; track option) {
                    <mat-option
                        [value]="option.id">{{ option.label }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
    @if (!multiple) {
        <mat-form-field class="flex"
        >
            <mat-label>{{ label }}</mat-label>
            <mat-select formControlName="selectElement"
                        [(value)]="value"
                        (selectionChange)="updateSelectElement()"
                        [disabled]="disabled">
                @if (hasSelectAll) {
                    <mat-option
                        value=""
                        class="select-single-all-option">All
                    </mat-option>
                }
                @for (option of allOptions; track option) {
                    <mat-option
                        [value]="option.id">{{ option.label }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
</div>
